import type { PropsWithChildren } from "react";

import { Typography } from "@aircall/tractor";

import type { PlaygroundSectionTitleProps } from ".";

export function PlaygroundSectionTitle({
  children,
  ...props
}: PropsWithChildren<PlaygroundSectionTitleProps>) {
  return (
    <Typography variant="headingMediumM" {...props}>
      {children}
    </Typography>
  );
}
